// src/components/Accounts/PaymentHistoryCard.js
import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function PaymentHistoryCard({ data }) {
  // ✅ Hooks must be called unconditionally
  const [expanded, setExpanded] = useState(false);

  // Safe destructuring with defaults
  const {
    planDuration = "N/A",
    paymentDate = "",
    amount = 0,
    planPrice = 0,
    paymentMode = "-",
    paymentId = "-",
  } = data || {};

  // Early return is OK *after* hooks were called
  if (!data) return null;

  return (
    <div className="bg-white rounded-xl shadow-md p-4 mb-4">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setExpanded((v) => !v)}
      >
        <div>
          <p className="text-sm text-gray-600 font-medium">{planDuration}</p>
          <p className="text-sm text-gray-500 mt-1">
            <span className="font-semibold">Date:</span> {paymentDate}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <p className="text-green-600 font-semibold text-lg">₹{amount}</p>
          {expanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </div>
      </div>

      {expanded && (
        <div className="mt-4 text-sm text-gray-700 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <p>
              <span className="font-semibold">Plan Price:</span> ₹{planPrice}
            </p>
            <p>
              <span className="font-semibold">Total Paid:</span> ₹{amount}
            </p>
          </div>
          <div>
            <p>
              <span className="font-semibold">Payment Mode:</span> {paymentMode}
            </p>
            <p>
              <span className="font-semibold">Payment ID:</span> {paymentId}
            </p>
          </div>
          <div className="col-span-2 mt-3 flex justify-between">
            <button className="text-blue-600 font-medium underline">
              Raise a Query
            </button>
            <button className="text-blue-600 font-medium underline">
              Download Receipt
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
